import { Select } from 'antd'
import React, { useCallback } from 'react'

import { GroupType } from '@/model/group'
import { selectCreatorOptions } from '@/redux/creator-selector'
import { useAppSelector } from '@/redux/utils'

import s from './creator-select.module.css'
import GroupTreeWithCheckboxList from './group-tree-with-checkbox-list'

export interface CreatorSelectProps {
  value?: number[]
  onChange?: (value?: number[]) => void
}

export default function CreatorSelect({
  value,
  onChange,
}: CreatorSelectProps) {
  const creatorOptions = useAppSelector(selectCreatorOptions)
  const dropdownRender = useCallback(() => (
    <GroupTreeWithCheckboxList
      value={value}
      onChange={onChange}
      options={creatorOptions}
      type={GroupType.Creator}
    />
  ), [value, onChange, creatorOptions])

  return (
    <Select<number[]>
      popupClassName={s.CreatorSelect}
      placeholder="Select creator(s)"
      mode="multiple"
      value={value}
      onChange={onChange}
      dropdownRender={dropdownRender}
      options={creatorOptions}
    />
  )
}
